import backend from '@common/backend';

const BASE = '/students';

export interface IGetStudentGradesParams {
	program_group_ids: number[];
	service_id: number;
	period_start: string;
	period_end: string;
}

export const studentGradesFromBE = (grade: any) => (Array.isArray(grade) ? {} : grade);

export const getStudentGrades = (studentId: number, params?: IGetStudentGradesParams) =>
	backend.get(`${BASE}/${studentId}/grades`, { params }).then(studentGradesFromBE);
